export enum WeightUnit {
  G = "g",
  Kg = "kg",
  Oz = "oz",
  Lb = "lb",
  T = "t",
}
